import { render, staticRenderFns } from "./ManageDashboard.vue?vue&type=template&id=0f9bc3e0&scoped=true&"
import script from "./ManageDashboard.vue?vue&type=script&lang=js&"
export * from "./ManageDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManageDashboard.vue?vue&type=style&index=0&id=0f9bc3e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9bc3e0",
  null
  
)

export default component.exports